module.exports = __webpack_public_path__ + "static/open-graph-card-ec90c20e2e4b2b3aa0cd0bce9fc31787.png";